import React, { createElement } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { path, is, map, take, contains } from 'ramda';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { route } from 'routes/Documents/routes/Background';

import { createSummaryTile } from '../containers/SummaryLoaderContainer';
import Separator from './Separator';

import icon from '../assets/background.svg';
import { formatDgDate } from 'lib/dateDisplay';
import createFetcher from 'lib/createFetcher';
import silhouette from '../assets/silhouette.png';
import { getLatestRankedDiagnosis } from 'lib/diagnosis';
import { getLatestFinishedCommitData } from 'lib/documentHandling';

const getImage = () => {
  createFetcher('/api/patient/v2/images/', {}, {}, false)
    .then(res => res.blob())
    .then(blob => {
      if (blob.size !== 0) {
        let image = document.querySelector('.avatar');
        let imageURL = URL.createObjectURL(blob);
        image.src = imageURL;
      }
    })
    .catch(err => console.log('Error loading patient image', err.status, err.statusText));
};

const formatDiagnosis = (diag, msg) => {
  if (diag && diag.date && diag.date[0] && diag.diagnosis) {
    let res = [];
    res.push(msg(`diagnosis.${diag.diagnosis}`));
    if (diag.type && contains(diag.type, ['RR', 'PP', 'SP'])) {
      res.push(`(${msg(`diagnosis.course.${diag.type}`)})`);
    }
    res.push(formatDgDate(diag.date));
    return res.join(' ');
  }
  return null;
};

const opt = opt => `background.opts.${opt}`;

const View = ({ data, session, localeMessage, diagnoses }) => (
  <Grid fluid style={{ height: '100%' }}>
    <Row middle="xs" style={{ height: '50%' }}>
      <Col xs={4}>
        {createElement('img', {
          className: 'avatar',
          src: silhouette,
          style: { width: '100%', height: 'auto', borderRadius: '50%' },
        })}
        {getImage()}
      </Col>
      <Col xs={8}>
        <Row>
          <Col xs={12}>
            {path(['lastName'], session) && path(['firstName'], session) && (
              <h6 className="bold">
                <span className="uppercase">{path(['lastName'], session)}</span>, {path(['firstName'], session)}
              </h6>
            )}
          </Col>
          <Col xs={12}>{path(['citizenId'], session) && <p className="bold">{path(['citizenId'], session)}</p>}</Col>
          <Col xs={12}>
            {path(['address', 'city'], session) && <p className="bold">{path(['address', 'city'], session)}</p>}
          </Col>
          <Col xs={12}>
            {getLatestRankedDiagnosis(diagnoses) && (
              <p className="bold">{formatDiagnosis(getLatestRankedDiagnosis(diagnoses), localeMessage)}</p>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
    <Row middle="xs">
      <Col xs>
        <Separator />
      </Col>
    </Row>
    <Row top="xs">
      {is(Number, path(['patientLength'], data[0])) && (
        <Col xs={3}>
          <Row>
            <Col xs>
              <p>{localeMessage('background.labels.height')}</p>
            </Col>
          </Row>
          <Row>
            <Col xs>
              <p className="bold">{path(['patientLength'], data[0])}</p>
            </Col>
          </Row>
        </Col>
      )}
      {is(Number, path(['patientWeight'], data[0])) && (
        <Col xs={3}>
          <Row>
            <Col xs>
              <p>{localeMessage('background.labels.weight')}</p>
            </Col>
          </Row>
          <Row>
            <Col xs>
              <p className="bold">{path(['patientWeight'], data[0])}</p>
            </Col>
          </Row>
        </Col>
      )}
      {path(['currentStatus'], data[0]) && (
        <Col xs={6}>
          <Row>
            <Col xs>
              <p>{localeMessage('background.labels.currentStatus')}</p>
            </Col>
          </Row>
          <Row>
            <Col xs>
              <p className="bold" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {map(o => localeMessage(opt(o)), take(2, path(['currentStatus'], data[0]))).join(', ')}
                {path(['currentStatus'], data[0]).length > 2 && ', ...'}
              </p>
            </Col>
          </Row>
        </Col>
      )}
    </Row>
  </Grid>
);

View.propTypes = {
  data: PropTypes.array,
  localeMessage: PropTypes.func,
  session: PropTypes.object,
  diagnoses: PropTypes.array,
};

const mapStateToProps = state => ({
  session: state.session,
  diagnoses: state.neuroDocuments.documents
    .filter(doc => doc.documentType === 'diagnosis')
    .map(doc => getLatestFinishedCommitData(doc)),
});

const viewWithRouter = withRouter(connect(mapStateToProps, null)(View));

export default createSummaryTile(viewWithRouter, {
  module: 'msBackground',
  localeId: 'background.title',
  routeTo: route,
  alwaysRender: true,
  icon,
});
